module.exports = __webpack_public_path__ + "static/media/cloud2.7eadad5f.png";